import ReactMarkdown from 'react-markdown'; 
import { linksSetup } from 'data';
import './ChatMessage.scss';

 
function ChatMessage({ role, content, selection }: ChatMessageProps) {
 
  const sendMessageToParent = (url: string) => {
    // Ensure that the window.parent exists 
    if (window.parent) {
      window.parent.postMessage({ action: 'openUrl', url }, '*');
    }  
  };

  return (
    <div className={`chat-message ${role}`}>
      <div className="chat-message__role">{role}</div>
      <div>
        <ReactMarkdown>{content.replace(/\n/g, '\n\n')}</ReactMarkdown>
      </div>
      {selection && selection.length > 0 && (
        <div className="chat-message__selection">
          {selection.map((option, index) => (
            <div key={index} className="chat-message__selection__option" onClick={() => sendMessageToParent(option.URL)}>
              <p>{option.collection}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ChatMessage;
